import type { AxiosResponse } from 'axios';
import { $api } from '../axios/axios';
import { ReferralPaymentStatus } from '@constants';

export default class ReferralService {
  static async getReferralsTotal(args: {
    status: ReferralPaymentStatus;
    nameOrSurname?: string;
  }): Promise<AxiosResponse> {
    return $api.post(`/recruiting-tool/api/v1/referrals/total`, args);
  }

  static async getReferrals({
    status,
    yearMonth,
    nameOrSurname,
  }: {
    status: ReferralPaymentStatus;
    yearMonth: string;
    nameOrSurname?: string;
  }): Promise<AxiosResponse> {
    return $api.post(`/recruiting-tool/api/v1/referrals?yearMonth=${yearMonth}`, { status, nameOrSurname });
  }

  static async resolveReferralStatus(id: string, accepted: boolean): Promise<AxiosResponse> {
    return $api.post(`/recruiting-tool/api/v1/referrals/${id}/${accepted}`);
  }

  static async exportReferrals(args: {
    fromDate: string;
    toDate: string;
    status: ReferralPaymentStatus;
    nameOrSurname?: string;
  }): Promise<AxiosResponse> {
    return $api.post(`/recruiting-tool/api/v1/referrals/export`, args, {
      responseType: 'blob',
    });
  }

  static async closeReferralPaymentPeriod({ yearMonth }: { yearMonth: string }): Promise<AxiosResponse> {
    return $api.post(`/recruiting-tool/api/v1/referrals/process/month?yearMonth=${yearMonth}`);
  }

  static async closeReferralPayment({ id }: { id: number }): Promise<AxiosResponse> {
    return $api.post(`/recruiting-tool/api/v1/referrals/process/${id}`);
  }

  static async transferReferralPayment({
    id,
    newStatus,
    message,
  }: {
    id: number;
    newStatus: ReferralPaymentStatus;
    message;
  }): Promise<AxiosResponse> {
    return $api.post(`/recruiting-tool/api/v1/referrals/change/status/${id}`, { newStatus, message });
  }
}
